import { Component } from '@angular/core';
import { RouterLink, Router } from '@angular/router';
@Component({
  selector: 'app-teacher-register-navbar',
  imports: [],
  templateUrl: './teacher-register-navbar.html',
  styleUrl: './teacher-register-navbar.css',
})
export class TeacherRegisterNavbar {
  constructor(private router: Router) {}
  goBack() {
    this.router.navigate(['/']);
  }
}
